<template>
    <div class='page'>
        <div class='page-content'>
            <!-- 列表数据 -->
            <el-table class="tableListAudit" ref="table" :data='shopProductList'  border  row-key='id' size='small'  
                      @selection-change='handleSelectionChange' v-loading='loading'>
                <el-table-column :show-overflow-tooltip='true' align='left' prop='userId' label='用户信息'
                                 width='130'>
                    <template slot-scope='scope'>
                        <div style='text-align: left'>{{ scope.row.userName }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='left' prop='userId' label='用户手机'
                                 width='130'>
                    <template slot-scope='scope'>
                        <div style='text-align: left'>{{ scope.row.userMobile ? scope.row.userMobile : "--" }}</div>
                    </template>
                </el-table-column>
                   <el-table-column :show-overflow-tooltip='true' align='center' label='组织名称' width='150'>
                    <template slot-scope='scope'>
                        <div>{{  scope.row.orgType == 1 ? scope.row.shopName  :  scope.row.storeName}}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='left' prop='userId' label='联系人手机'
                                width='130'>
                    <template slot-scope='scope'>
                     <div style='text-align: left'>{{ scope.row.orgType == 2 ? scope.row.storeContactPhone : scope.row.contactPhone }}</div>
                    </template>
                </el-table-column>
                  <el-table-column :show-overflow-tooltip='true' align='center'  label='组织类型'  width='100'>
                    <template slot-scope='scope'>
                          <div> {{ scope.row.orgType == 1 ? '店铺' : (scope.row.orgType == 2 ? '门店' : '--') }}</div>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='是否发放' width='100'>
                    <template slot-scope='scope'>
                       <div>{{scope.row.isSend == 1 ? "是" : "否" }}</div>
                    </template>
                </el-table-column>
              
                <el-table-column  :show-overflow-tooltip='true'  align='center'
                                 label='服务费类型' width='100'>
                    <template slot-scope='scope'>
                        <div>{{thousandSeparator(scope.row.serviceRadio) }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='消费金额' width='130'>
                      <template slot-scope='scope'>
                        <div>{{thousandSeparator(scope.row.money)}}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='是否审核' width='100'>
                      <template slot-scope='scope'>
                        <div>{{thousandSeparator(scope.row.auditStatus == 1 ?  "是" : "否")}}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='审核人' width='150'>
                      <template slot-scope='scope'>
                        <div>{{thousandSeparator(scope.row.auditUserName)}}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='审核时间' width='200'>
                      <template slot-scope='scope'>
                        <div>{{thousandSeparator(scope.row.auditTime)}}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='凭证总额' width='150'>
                      <template slot-scope='scope'>
                        <div>{{ scope.row.simulatedMoney ?  thousandSeparator(scope.row.simulatedMoney) : '--' }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='备注' width='200'>
                      <template slot-scope='scope'>
                        <div>{{scope.row.remarks ? scope.row.remarks : '--' }}</div>
                    </template>
                </el-table-column>
                  <el-table-column
                      fixed="right"
                      align="center"
                      label="操作"
                      width="150"
                    >
                    <template slot-scope="scop">
                        <div class="operate" v-if="scop.row.auditStatus == 1" @click="detailedQuery(scop.row)">
                                明细查询
                        </div>
                        <div style="display: flex; text-align: center; justify-content: center;" v-else-if="scop.row.auditStatus == 0">
                            <div class="operate" @click="addShopProduct(scop.row)">
                                 审核
                            </div>
                            <div class="operate" style="margin: 0 1.25rem ; color: #f56c6c;" @click="deleteAudit(scop.row)">
                             撤销
                            </div>
                          
                        </div>
                        <div v-else style="display: flex; text-align: center; justify-content: center;">
                            --
                        </div>
                      </template>
            </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
        </div>
        <!-- 确认审核弹窗 -->
        <el-dialog
            v-model="dialogVisible"
            title="审核"
            width="500"
            :visible.sync='dialogVisible'
            :append-to-body="true" 
          >
           <span style="font-size: 24px; color: #181818;  width: 85px;" >密码：</span>
           <el-input show-password type="password" v-model="operationPassWord" style="width: 240px" placeholder="请输入密码" />
            <div style="display: flex;align-items: center; margin-top: 20px;">
                <span style="font-size: 24px; color: #181818; width: 85px;" >备注：</span>
                <el-input type="textarea" v-model="remark"   autosize placeholder="合同服务费、代理服务费、奖励等请详细注明" /> 
            </div>
            <template #footer>
              <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="Confirm">
                  确认
                </el-button>
              </div>
            </template>
        </el-dialog>
        <!-- 明细查询弹窗 -->
         <el-dialog
            title="明细查询"
            v-model="detailedQueryVisible"
            :visible.sync='detailedQueryVisible'
            width="90%"
            :append-to-body="true"
        >
         <DetailedQuery v-if="detailedQueryVisible" :detailedQueryRow="detailedQueryRow"></DetailedQuery>
        </el-dialog>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import DetailedQuery from './DetailedQuery.vue';
import {
    importDate,
    get,
    postJson
} from '@/utils/request.js';
import WangEditor from '@/components/common/wangeditor';
// import ProductEdit from '../ProductEdit.vue';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { SHOP, SHOP_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectShop,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        WangEditor,
        DetailedQuery
        // ProductEdit
    },
    name: 'goods',
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductList();
                this.getShopProductList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductList();
                this.getShopProductList();
                this.$emit('resetCheckState');
            }
        }
    },
 
    data() {
        return {
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            saleMode: 1,
            saleModeTwo: '',
            showShop: 0,
            showStatus: 0,
            remark:"",
            operationPassWord:"",
            dialogImageUrl: '', //
            detailedQueryVisible:false,
            dialogVisible: false,
            disabled: false,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopProductList: [],
            shopProduct: {},
            btnLoading: false,
            fileList: [],
            list: '',
            auditStatus: [],
            detailedQueryRow:{}
        };
    },
    created() {
        this.getShopProductList();
    },
    methods: {
       thousandSeparator(value) {
                       if (!value && value !== 0) return '';
                            const num = Number(value);
                            if (isNaN(num)) return value;

                            // 如果大于等于1000，使用千分位格式化
                            if (num >= 1000) {
                            return num.toLocaleString('en-US');
                            }
                            return num;
                    },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopProductList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductList = [];
        },
        refreshShopProductList() {
            this.resetShopProductList();
            this.getShopProductList();
        },
        // 数据
        getShopProductList(query = {}) {
          this.loading = true;
            get(`/shop/simulated/findList`, {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        // 确认审核
        addShopProduct(row) {
          this.auditSimulatedID = row.id
          this.dialogVisible =true
          
        },

        //删除 
        deleteAudit(row){
           this.$confirm('确定撤销所选项吗？', '提示', {
                type: 'warning'
            }).then(()=>{
              get(`/shop/simulated/updateById`,{id:row.id}).then(res=>{
                    if(res.success){
                      this.$message({
                           message: res.msg,
                           type: 'success',
                           duration: 2000
                      })
                     this.getShopProductList()
                    }else{ 
                        this.$message({
                           message: res.msg,
                           type: 'error',
                           duration: 2000
                      })
                    }
                     
              })
            })
        },
        // 明细查询
        detailedQuery(row){
             this.detailedQueryVisible = true;
             this.detailedQueryRow = row
        },
        Confirm(){
            if (this.operationPassWord == '' ) {
                return  this.$message({
                          message: '请输入密码',
                          type: 'warning',
                          duration: 2000
                      });
            }
           
            if (this.remark == '' ) {
                return  this.$message({
                          message: '请输入备注',
                          type: 'warning',
                          duration: 2000
                      });
            }
            let obj = {
                id:this.auditSimulatedID,
                operationPassWord:this.operationPassWord,
                remarks:this.remark
            }
            postJson('/shop/simulated/auditSimulated',obj).then((res)=>{
                if(res.success){
                    this.$message({
                        message:res.msg,
                        type:'success',
                        duration:2000
                    })
                    this.getShopProductList()
                    this.dialogVisible = false
                    this.operationPassWord = ""
                    this.remark = ""
                    
                }else{
                    this.$message({
                        message:res.msg,
                        type:'warning',
                        duration:2000
                    }) 
                }
            })      
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductList();
        },
       

    }
};
</script>

<style lang='scss' scoped>
.tableListAudit{
    overflow-y: auto;
}
    ::v-deep .is-scrolling-none{
         min-height: calc(50vh - 100px) !important;
    }
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
}

.classInput {
    width: 200px;
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}

.el-icon-arrow-down {
    font-size: 12px;
}

::v-deep .el-dropdown {
    font-size: 12px;
    color: #409eff;
}
.operate{
    color: #409eff;
    cursor: pointer;
}
</style>
